import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Attach bearer token from localStorage as fallback (cookies may be blocked in previews)
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("primates_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export const CATEGORY_LABELS = {
    trendy: "Trendy",
    traditional: "Traditional",
    artisanal: "Artisanal",
    formal: "Formal",
    athleisure: "Athleisure",
    eco_friendly: "Eco / Skin Friendly",
    occasion_wear: "Occasion Wear",
};

export const GENDER_LABELS = { men: "Men", women: "Women", unisex: "Unisex" };
